"use client"

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"
import { useEffect } from "react"

let calledToursCategories: any = false
export const useToursCategories = () => {
  const toursCategories = useAppSelector(state => state.tour.tours_categories)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (calledToursCategories || !!toursCategories.called) return;
    calledToursCategories = true
    dispatch(thunks.tours_categories({}))
  }, [toursCategories.called])

  return toursCategories
}